import {getDefaultPieFormatting} from "@/containers/E4ImpactMBA/charts/pie";

const transformData = [
    'Cereals', 'Cocoa', 'Coffee', 'Dairy', 'Fertilizers', 'Fodder', 'Forestry',
    'Fruit', 'Herbalism', 'High tech', 'Honey', 'Meat', 'Nuts', 'Pesticides',
    'Poultry', 'Rice', 'Seafood', 'Seeds', 'Sugar', 'Vegetables'
];

/**
 * question: What is your specialty?
 * == baseline
 * question4
 * 
 * @param props 
 * @returns 
 */
export const specialtyAgrifoodSectorChartCalculation = (props: any) => {
    return getDefaultPieFormatting(
        'Specialty of the agrifood sector',
        transformData.map((value) => ({
            name: value,
            y: props.baselineSubmissions.filter((submission: any) => {
                for (let i = 0; i < transformData.length; i++) {
                    if (submission[`question4_${i}`] === value) {
                        return true;
                    }
                }
                
                return false;
            }).length
        }))
    )
}